import React from 'react';
import { Box, Typography } from '@mui/material';
import { SaveTicketButton } from '../actions';
import GoBackButton from '../../../../common/components/styled-ui-elements/GoBackButton';

/**
 * TicketCreateHeader - Professional header section for ticket creation
 * Contains title, description, and action buttons
 */
export const TicketCreateHeader: React.FC = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#ffffff',
        borderBottom: '2px solid #3b82f6',
        p: 2.5,
        position: 'relative',
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box>
          <Typography 
            variant="h5" 
            component="h1" 
            fontWeight={600} 
            color="#1e293b" 
            sx={{ mb: 0.5 }}
          >
            Create New Ticket
          </Typography>
          <Typography 
            variant="body2" 
            color="#64748b" 
            sx={{ fontSize: '0.9rem' }}
          >
            Complete all required fields to create a new support ticket
          </Typography>
        </Box>
        
        <Box display="flex" alignItems="center" gap={2}>
          <SaveTicketButton />
          <GoBackButton />
        </Box>
      </Box>
    </Box>
  );
};

export default TicketCreateHeader;
